export const getTreatmentOptions = (t) => [
    { value: true, label: t('global.yes') },
    { value: false, label: t('global.no') }
]